import React, { Component } from "react";
import axios from 'axios'
import { Input,Button,Form,Modal } from "antd";
import { strings } from 'res';
import TextArea from "antd/lib/input/TextArea";
import { Editor } from 'react-draft-wysiwyg';

export class Basic extends Component {
  constructor(props){
    super(props)
    this.state = {
      homePageInd:{},
      visible: false,
      updateMessage:"",
      editorState:{},
      editorStateEn:{}
    }
    this.handleChange = this.handleChange.bind(this);
    this.onFinish = this.onFinish.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.onEditorStateChangeEn = this.onEditorStateChangeEn.bind(this);
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleOk = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  //Markdown
  onEditorStateChange = (editorState) => {
    this.setState({
      editorState: editorState,
    });
  }

  onEditorStateChangeEn = (editorState) => {
    this.setState({
      editorStateEn: editorState,
    });
  }

  componentDidMount(){
    axios.get(`${strings.url.content_url}/valuesPage/read`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin":"*"
      }
    }).then(doc=>{
      if(this.props.bahasa === "Indonesia"){
        this.setState({
          homePageInd:doc.data.valuesInd[0]
        })
      }else{
        this.setState({
          homePageInd:doc.data.valuesEng[0]
        })
      }
     
    })
  }

  handleChange(event){
    this.setState({
      homePageInd:{
        ...this.state.homePageInd,
        [event.target.name]: event.target.value
       }
    })
  }

   onFinish = (values) =>{
    console.log(this.state)
    if(this.props.bahasa === "Indonesia"){
      axios.post(`${strings.url.content_url}/valuesPage/updateIndonesia`,this.state.homePageInd, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin":"*"
        }
      }).then(doc=>{
        this.setState({
          visible: true,
          updateMessage:doc.data.msg
        });
      })
    }else{
      axios.post(`${strings.url.content_url}/valuesPage/updateEnglish`,this.state.homePageInd, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin":"*"
        }
      }).then(doc=>{
        this.setState({
          visible: true,
          updateMessage:doc.data.msg
        });
      })
    }
  }

  render() {
    return (
      <div>
          <Modal
          title="Message!"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <h3 style={{textAlign:"center"}}>{this.state.updateMessage}</h3>
        </Modal>
        <h1>{this.props.bahasa}</h1>
        <Form onFinish={this.onFinish}>
        <label>Jumbotron</label><br/><label style={{color:"red"}}>(Recommended Max 10 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.header} name="header" placeholder="Header" />
        <br />
        <br />
        <label>Jumbotron Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.header_desc}name="header_desc" placeholder="Header Description" />    
        <br />
        <br />
        <label>Value Chains</label><br/><label style={{color:"red"}}>(Recommended Max 10 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.value_chains} name="value_chains" placeholder="Value Chains" />
        <br />
        <br />
        <label>Value Chains Desc</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.value_chains_desc} name="value_chains_desc" placeholder="Value Chains Description" />
        <br />
        <br />
        <label>Shrimp</label><br/><label style={{color:"red"}}>(Recommended Max 10 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.shrimp} name="shrimp" placeholder="Shrimp" />
        <br />
        <br />
        <label>Shrimp Desc</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.shrimp_desc} name="shrimp_desc" placeholder="Shrimp Description" />
        <br />
        <br />
        <label>Seaweed</label><br/><label style={{color:"red"}}>(Recommended Max 10 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.seaweed}name="seaweed" placeholder="Seaweed" />
        <br />
        <br />
        <label>Seaweed Desc</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.seaweed_desc} name="seaweed_desc" placeholder="Seaweed Description" />
        <br />
        <br />
        <label>Pengasius</label><br/><label style={{color:"red"}}>(Recommended Max 10 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.pengasius}name="pengasius" placeholder="Pengasius" />
        <br />
        <br />
        <label>Pengasius Desc</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.pengasius_desc}name="pengasius_desc" placeholder="Pengasius Description" />
        <br />
        <br />
        <label>Milkfish</label><br/><label style={{color:"red"}}>(Recommended Max 10 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.milkfish}name="milkfish" placeholder="Milkfish" />
        <br />
        <br />
        <label>Milkfish Desc</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.milkfish_desc} name="milkfish_desc" placeholder="Milkfish Description" />
        <br />
        <br />
        <label>Catfish</label><br/><label style={{color:"red"}}>(Recommended Max 10 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.catfish}name="catfish" placeholder="Catfish" />
        <br />
        <br />
        <label>Catfish Desc</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.catfish_desc} name="catfish_desc" placeholder="Catfish Description" />
        <br />
        <br />
        <Form.Item >
          <Button htmlType="submit" type="primary" style={{width:"100%"}} >Submit</Button>
        </Form.Item>
        </Form>
      </div>
    );
  }
}

export default Basic;
